import { Drawn, type BrandMarkProps } from "./Drawn.tsx";
import { logo } from "./generated/logo.ts";

/**
 * The logo, the B mark and the wordmark, where there is room for the word. A module of its own, so
 * a surface off the eager path can load it on demand and the authenticated entry carries only the
 * B mark its rail draws.
 */
export function BatonLogo(props: BrandMarkProps) {
  return <Drawn shape={logo} {...props} />;
}
